import { render, staticRenderFns } from "./add-config-modal.vue?vue&type=template&id=125a6228&scoped=true"
import script from "./add-config-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./add-config-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./add-config-modal.vue?vue&type=style&index=0&id=125a6228&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a6228",
  null
  
)

export default component.exports